var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.646 17.0149C16.0748 18.6153 15.1251 20.2603 13.5247 20.6891C11.9243 21.118 10.2792 20.1682 9.85042 18.5678M2.05689 10.6134C1.6674 9.21525 2.07244 7.70361 3.10884 6.6875M12.1464 4.74097C12.4506 4.19367 12.5508 3.53217 12.3759 2.87957C12.0186 1.54591 10.6477 0.754452 9.31406 1.11181C7.9804 1.46916 7.18894 2.84 7.5463 4.17367C7.72116 4.82627 8.13869 5.34904 8.67579 5.67091M20.3191 5.72012C19.9573 4.31451 18.8507 3.20792 17.4451 2.84614M17.4907 8.4454C17.1337 7.11327 16.1808 5.99931 14.8415 5.34858C13.5023 4.69784 11.8864 4.56365 10.3493 4.9755C8.8122 5.38736 7.47988 6.31154 6.6454 7.54473C5.81092 8.77792 5.54264 10.2191 5.89958 11.5512C6.49016 13.7553 6.37548 15.5137 6.00253 16.8498C5.57746 18.3727 5.36493 19.1341 5.42235 19.287C5.48804 19.4619 5.53556 19.5099 5.70979 19.5774C5.86208 19.6364 6.50185 19.465 7.78139 19.1222L19.6465 15.9429C20.926 15.6001 21.5658 15.4286 21.6682 15.3014C21.7853 15.1558 21.8024 15.0905 21.7719 14.9061C21.7451 14.745 21.1804 14.1919 20.0508 13.0856C19.0598 12.1149 18.0813 10.6495 17.4907 8.4454Z",
    stroke: "#147AF3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifBell);
export default __webpack_public_path__ + "static/media/NotifBell.2f8bece0f9b881476ac552611482f98b.svg";
export { ForwardRef as ReactComponent };